import React from "react";
import { motion } from "framer-motion";
import ContactForm from "../pages/ContactForm";
import LocationSection from "../pages/LocationSection";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const ContactCards = () => {
  return (
    <div>

      {/* 🌟 First Section: Hero */}
    <section className="relative h-[60vh] flex items-center justify-center text-white overflow-hidden">
  {/* 🎥 Background Video */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/ContactUs.mp4"
    autoPlay
    muted
    loop
    playsInline
  />

  {/* 💜 Overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

  {/* 📝 Foreground Heading */}
  <motion.h2
  className="
    relative z-20 font-extrabold
    text-white [@media(hover:hover)]:text-transparent
    text-3xl sm:text-5xl md:text-6xl lg:text-7xl
  "
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "2px #ffffff",
    letterSpacing: "0.05em",
    lineHeight: "1.1",
    textAlign: "center",
  }}
  initial={{ opacity: 0, x: -100 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 1.2, ease: "easeOut" }}
>
  Contact Us
</motion.h2>
</section>
      

{/* Contact Form Section */}
<section
  className="w-full px-4 sm:px-6 lg:px-8 mt-10 mb-0"
  style={{
    height: "820px",        // mobile & tablet exact height
  }}
>

  <div
    className="
      w-full 
      bg-white shadow-lg rounded-xl
      px-6 sm:px-10 py-10
    "
    style={{
      height: "100%",        // fill section height
    }}
  >
    <ContactForm />
  </div>

</section>





      {/* 📍 Location Section */}
      <section className="w-full h-auto !mb-0 !pb-0">
        <LocationSection />
      </section>

      {/* 🌈 Footer Curved Section */}
      <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto !pb-0 !mb-0">

        {/* Curved white background */}
        <div className="absolute top-[160px] left-0 w-full">
          <div
            className="
              bg-white 
              rounded-t-[12rem] 
              sm:rounded-t-[14rem] 
              min-h-[40vh]         /* reduced height—white space fix */
              sm:min-h-[60vh] 
              pb-6                /* reduced padding to remove gap */
            "
          ></div>
        </div>

        {/* Footer Content */}
        <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-32 pb-10">

          {/* Footer heading */}
          <div className="text-center mt-[120px] mb-10">
            <h2 className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]">
              Collaborate for Success
            </h2>
            <p className="text-gray-700 text-lg sm:text-xl font-medium">
              Working together fosters innovation, creativity, and achievement.
            </p>
          </div>

          {/* Footer grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">

            {/* About us */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
              <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
              <p className="mb-4">
                Wissenstil Solutions is a specialized software company driving digital innovation.
              </p>
            </div>

            {/* Services */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
              <ul className="space-y-2">
                <li>Image Analysis</li>
                <li>Anomaly Detection</li>
                <li>Medical Coding</li>
              </ul>
            </div>

            {/* Useful links */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
              <ul className="space-y-2">
                {[
                  { name: "About Us", path: "/about" },
                  { name: "Wise Services", path: "/services" },
                  { name: "Wise Products", path: "/products" },
                  { name: "Contact Us", path: "/contact" },
                ].map((link, index) => (
                  <li
                    key={index}
                    className="transition-transform duration-300 hover:translate-x-2"
                  >
                    <Link to={link.path} className="relative hover:text-purple-700">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
              <p>
                Wissenstil Solutions Private Ltd.<br />
                Brigade IRV Centre, Floors 09 & 10,<br />
                Whitefield, Bangalore, 560066.
              </p>

              <div className="mt-4 space-y-3">
                <p className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-gray-900" />
                  <span className="font-medium text-gray-900">
                    +91 9986158307
                  </span>
                </p>

                <p className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-gray-900" />
                  <span className="font-medium text-gray-900">
                    Manish.palliyil@wissenstil.com
                  </span>
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactCards;